export default "__VITE_ASSET__e9279faf__"